export enum StoreKeys {
	DEAL = 'deal',
	CACHE = 'cache',
	USER = 'user',
	CONFIGURATOR = 'configurator',
	BRANDING = 'branding',
	FULL_FEED_IN = 'fullFeedIn',
	PRODUCT_STORE = 'productStore',
	USER_TENANT = 'userTenantStore',
	USER_TENANT_IDS = 'userTenantIdsStore',
	TENANTS = 'tenantStore',
	SELECTABLE_FILES = "selectableFilesStore",
	SUPER_ADMIN_ACTIVE_TENANT = "superAdminActiveTenant",
	CONFIGURATOR_PRODUCTS = "configuratorProducts",
	CONFIGURATOR_ECONOMY_SETTINGS = "configuratorEconomySetting",
	CONFIGURATOR_AC_CONNECTION_SETTINGS = "configuratorACConnectionSetting",
	CONFIGURATOR_ARTEFACTS = "configuratorArtefacts",
	CONFIGURATOR_ARTEFACT_PERMISSIONS = "configuratorArtefactPermissions",
	LOGS = "logsStore",
	CONFIGURATOR_SUMMARY = "configuratorSummary",
	CONFIGURATOR_EFFECTIVE_ROOF = "configuratorEffectiveRoof",
	IS_SUPER_ADMIN = "isSuperAdminStore",
}
